import { COUNTRY } from '../../actions/action_types';

export const allowedLocales = [
  { value: 'en', label: 'English', apiKey: 'USA', currency: 'USD', lang: 'en' },
  { value: 'fr', label: 'French', apiKey: 'CANADA', currency: 'CAD', lang: 'fr' },
];

const getBrowserLanguage = () => {
  if (typeof navigator === "undefined") return "en";
  const browserLanguage = navigator.language || navigator.userLanguage || "en";
  return browserLanguage.toLowerCase().startsWith("fr") ? "fr" : "en";
};

export const getLocaleSelection = ({ userCountry } = {}) => {
  const normalizedCountry = userCountry?.toUpperCase();
  const browserLanguage = getBrowserLanguage();

  if (normalizedCountry === "USA") {
    return {
      ...allowedLocales[0],
      userCountry: "USA",
      showSelector: false,
    };
  }

  if (normalizedCountry === "CANADA") {
    const selectedLocale =
      allowedLocales.find((item) => item.value === browserLanguage) || allowedLocales[0];

    return {
      ...selectedLocale,
      userCountry: "CANADA",
      showSelector: true,
    };
  }

  return {
    ...(allowedLocales.find((item) => item.value === browserLanguage) || allowedLocales[0]),
    userCountry: null,
    showSelector: true,
  };
};

const INITIAL_STATE = {
  selectedCountry: getLocaleSelection(),
  countriesList: allowedLocales,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COUNTRY:
      return { ...state, selectedCountry: action.payload, countriesList: allowedLocales };
    default:
      return state;
  }
};
